import AbstractRepository from "@/repositories/AbstractRepository";

export default class NotificationRepository extends AbstractRepository {
    protected static resource: string = "ptf-request-notification";

    protected static defaultFields: string[] = [
        "uuid",
        "trigger",
        "channels",
        "ownersUuid",
        "status",
        "type",
        "topic.uuid",
        "topic.title",
        "budgetAllocation.uuid",
        "budgetAllocation.label",
        "affected.uuid",
        "affected.displayName",
        "follower.uuid",
        "follower.displayName",
        "documentTypes",
        "isActive",
        "requesters.uuid",
        "requesters.displayName"
    ];
}
